import React,{useEffect} from "react";
import { createContext, useContext } from "react";

export const userSessionContext = createContext({
  score: null,
  user: null,
  logIn: () => {},
  logOut: () => {},
});

export function useUserSession() {
  const { score,user, logIn, logOut } = useContext(userSessionContext);
  
  useEffect(() => {
    const us=JSON.parse(localStorage.getItem("user"))  
    if(us===null)
   { 
    localStorage.setItem("user",JSON.stringify(user))      
 }
 else if(us!==null && !us.Islogin)
   { localStorage.setItem("user",JSON.stringify(user))      
 }
  }, [user]);

  return { score,user, logIn, logOut };
}
